import { createContext, useState } from "react";

export const OpacityContext = createContext(null)

export default ({children}) => {
    const [opacity, setOpacity] = useState('')

    const eleOpacity = {
        visibility: {
            set: setOpacity,
            get: opacity,
        }
    }

    return <OpacityContext.Provider value={eleOpacity}>{children}</OpacityContext.Provider>
}